var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleSignIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9002 8.17566C14.9008 7.6504 14.8573 7.12606 14.7701 6.6084H7.64987V9.57699H11.728C11.6446 10.0511 11.4679 10.5031 11.2088 10.9056C10.9496 11.3082 10.6133 11.653 10.2201 11.9193V13.8463H12.654C14.0791 12.5049 14.9002 10.5212 14.9002 8.17566Z",
    fill: "#3081F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64969 15.708C9.68719 15.708 11.4028 15.025 12.6538 13.8474L10.2199 11.9204C9.54248 12.3893 8.67002 12.657 7.64969 12.657C5.68035 12.657 4.00882 11.3017 3.41109 9.47534H0.903797V11.4612C1.53221 12.7378 2.49582 13.8109 3.68703 14.5608C4.87825 15.3108 6.25019 15.7079 7.64969 15.708Z",
    fill: "#3081F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4111 9.47541C3.0951 8.5184 3.0951 7.48203 3.4111 6.52502V4.53918H0.9038C0.375156 5.61309 0.0998383 6.79833 0.0998383 8.00022C0.0998383 9.2021 0.375156 10.3873 0.9038 11.4612L3.4111 9.47541Z",
    fill: "#3081F6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64969 3.34339C8.72642 3.32543 9.76683 3.74075 10.546 4.49957L12.701 2.29962C11.3345 0.989374 9.52426 0.270024 7.64969 0.292376C6.25019 0.292441 4.87825 0.689602 3.68703 1.43952C2.49582 2.18943 1.53221 3.26259 0.903797 4.53918L3.41109 6.52501C4.00882 4.69869 5.68035 3.34339 7.64969 3.34339Z",
    fill: "#3081F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleSignIn);
export default __webpack_public_path__ + "static/media/google-sign-in.e62b37818c33b83df938b23073bbd29a.svg";
export { ForwardRef as ReactComponent };